export const getCurrentVersion = () => "1.2.0"